<template>
  <h2 class="titleStepForm">
    Foreign Account Tax Compliance ACT <sup>(FATCA)</sup>
  </h2>
  <div class="">
    <div class="mb-3 border-bottom pb-3">
      <h3 class="font-size-16">
        Are you a citizen of any country other than Trinidad
        and Tobago?
      </h3>
      <p class="mb-0">
        <strong
          class="font-size-13 font-weight-500 text-warning"
          >REQUIREMENTS:</strong
        >
        <template v-if="isPdf">
        If yes, copies of relevant passport(s) to be
        provided.
        </template>
        <template v-if="!isPdf">
        If yes, copies of relevant passport(s) to be provided.
        </template>
      </p>
      <div class="row">
        <div class="col-auto">
          <label
            for="yesTabago"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.tobagoRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.tobagoRadio"
              class="inputRadioCstm d-none"
              id="yesTabago"
              value="true"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .tobagoRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noTabago"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.tobagoRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.tobagoRadio"
              class="inputRadioCstm d-none"
              id="noTabago"
              disabled
              value="false"
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .tobagoRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 border-bottom pb-3">
      <h3 class="font-size-16">
        Are you a US Citizen, Resident or Green Card Holder?
      </h3>
      <p class="mb-0">
        <strong
          class="font-size-13 font-weight-500 text-warning"
          >REQUIREMENTS:</strong
        >
        W-9 or W-8BEN , Document showing Immigration Status.
      </p>
      <div class="row mt-2 align-items-center">
        <div class="col-md-4">
          <div class="d-block">
            <label class="font-size-14">SSN No</label>
            <template v-if="isPdf">
            <input
              type="text"
              v-model="form.personal.ssn_no"
              class="form-control"
              placeholder="SSN No"
              :class="{
                'is-invalid':
                  v$.form.personal.ssn_no.$error,
              }"
              disabled
            />
            </template>
            <template v-if="!isPdf">
            <input
              type="text"
              v-model="form.personal.ssn_no"
              class="form-control"
              placeholder="SSN No"
              :class="{
                'is-invalid': v$.form.personal.ssn_no.$error,
              }"
              disabled
            />
            </template>
            <div
              v-for="(personal, index) in v$.form.personal
                .ssn_no.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="yesCitizen"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.citizenRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.citizenRadio"
              value="true"
              class="inputRadioCstm d-none"
              id="yesCitizen"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .citizenRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noCitizen"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.citizenRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.citizenRadio"
              value="false"
              class="inputRadioCstm d-none"
              id="noCitizen"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .citizenRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 border-bottom pb-3">
      <template v-if="isPdf">
      <h3 class="font-size-16">
        Do you have a US address?
      </h3>
      </template>
      <template v-if="!isPdf">
      <h3 class="font-size-16">Do you have a US address?</h3>
      </template>
      <p class="mb-0">
        <strong
          class="font-size-13 font-weight-500 text-warning"
          >REQUIREMENTS:</strong
        >
        W-9 or W-8BEN
      </p>
      <div class="row">
        <div class="col-auto">
          <label
            for="yesAddress"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.addressRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.addressRadio"
              value="true"
              class="inputRadioCstm d-none"
              id="yesAddress"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .addressRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noAddress"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.addressRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.addressRadio"
              value="false"
              class="inputRadioCstm d-none"
              id="noAddress"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .addressRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3 border-bottom pb-3">
      <h3 class="font-size-16">
        Are you giving instructions for the transfer of
        dividends/ other income to a US Account?
      </h3>
      <p class="mb-0">
        <strong
          class="font-size-13 font-weight-500 text-warning"
          >REQUIREMENTS:</strong
        >
        W-9 or W-8BEN
      </p>
      <div class="row">
        <div class="col-auto">
          <label
            for="yesIncomeUs"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.incomeUsRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.incomeUsRadio"
              value="true"
              class="inputRadioCstm d-none"
              id="yesIncomeUs"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .incomeUsRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noIncomeUs"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.incomeUsRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.incomeUsRadio"
              value="false"
              class="inputRadioCstm d-none"
              id="noIncomeUs"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .incomeUsRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-3">
      <h4 class="text-center font-size-14 mb-0">
        If you have answered “yes” to any of the questions
        above, FATCA Documentation to be completed
      </h4>
    </div>
  </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewFatca",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["form"],
    validate: true,
    }),
  ],
};
</script>
